<tax-modal-header>{{ 'rca.alarm.modal.title' | translate }}</tax-modal-header>

<tax-modal-content class="alert">
  <tax-icon name="alert"></tax-icon>
  <div class="alert-message" data-qa="alert-message">
    <p *ngFor="let item of alertMessage | translate | taxTextSeparator: '.'">
      {{ item }}
    </p>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button
    data-qa-button="ok"
    class="button_blue ui-kit-align-right"
    (click)="navigateToEditRetailPlace()"
  >
    OK
  </button>
</tax-modal-footer>
